module.exports = __webpack_public_path__ + "media/jobs/powered-by-monster@2x-29096b4d.svg";